// extracted by mini-css-extract-plugin
export default {"selected-tags":"FmF5ofWi0S2gwTR8UMaK","tag":"iYxPLJIMmKE85ELFVGNA"};